import { onDocumentReady } from '../../../scripts/util/events';
import { smoothScroll } from '../../../scripts/plugins/smoothScroll';

onDocumentReady(() => {
  acfHeroBlock();
});

const acfHeroBlock = () => {
  document.querySelectorAll('.js-acf-hero-block').forEach((block) => {
    block
      .querySelector('.js-anchor-link')
      .addEventListener('click', (event) => {
        event.preventDefault();

        const headerOffset =
          parseInt(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--header-offset'
            ),
            10
          ) || 0;

        const { bottom } = block.getBoundingClientRect();
        const scrollTop = window.scrollY + bottom - headerOffset;

        smoothScroll(scrollTop, { duration: 1000 });
      });
  });
};
